import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import * as S from './styled'

type Props = {
  isOpen: boolean
  onClose: () => void
  width?: string
  height?: string
  closeOnBackdropClick?: boolean
  showCloseButton?: boolean
  children: React.ReactNode
}

const Modal = ({
  isOpen,
  onClose,
  width = '500px',
  height = 'auto',
  closeOnBackdropClick = true,
  showCloseButton = true,
  children,
}: Props) => {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null)

  useEffect(() => {
    let element = document.getElementById('modal-root')
    if (!element) {
      element = document.createElement('div')
      element.id = 'modal-root'
      document.body.appendChild(element)
    }
    setPortalElement(element)

    return () => {
      if (element && !document.getElementById('modal-root')) {
        document.body.removeChild(element)
      }
    }
  }, [])

  useEffect(() => {
    if (isOpen) {
      const originalOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = originalOverflow
      }
    }
  }, [isOpen])

  const handleBackdropClick = () => {
    if (closeOnBackdropClick) {
      onClose()
    }
  }

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  if (!portalElement) return null

  return createPortal(
    <S.ModalBackdrop $isOpen={isOpen} onClick={handleBackdropClick}>
      <S.ModalContentWrapper
        $width={width}
        $height={height}
        onClick={handleContentClick}
      >
        {showCloseButton && <S.CloseButton onClick={onClose}>×</S.CloseButton>}
        {children}
      </S.ModalContentWrapper>
    </S.ModalBackdrop>,
    portalElement
  )
}

export default Modal
